import { useNavigate } from 'react-router-dom'
import { MapPinIcon, EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline'

export default function Footer() {
  const navigate = useNavigate()

  const go = (path: string) => {
    navigate(path)
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50)
  }

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Main Footer */}
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="space-y-4">
            <img src="/logo.png" alt="PhoneMedic" className="h-10 w-auto brightness-0 invert" />
            <p className="text-gray-400 text-sm leading-relaxed">
              Spezialist für MacBook Platinen-Reparatur und Mikrochip-Löten. Auch iPhone und Android – bundesweiter Einsende-Service.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">Leistungen</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Platinen-Reparatur', path: '/platinen-reparatur' },
                { label: 'MacBook Reparatur', path: '/macbook-reparatur' },
                { label: 'MacBook startet nicht', path: '/macbook-startet-nicht' },
                { label: 'MacBook Wasserschaden', path: '/macbook-wasserschaden' },
                { label: 'MacBook Akku tauschen', path: '/macbook-akku-tauschen' },
                { label: 'MacBook Display Reparatur', path: '/macbook-display-reparatur' },
                { label: 'iPhone Reparatur', path: '/repair' },
                { label: 'iPhone Akku tauschen', path: '/iphone-akku-tauschen' },
                { label: 'iPhone Display Reparatur', path: '/iphone-display-reparatur' },
                { label: 'Samsung Reparatur', path: '/repair' },
              ].map((item) => (
                <li key={item.path + item.label}>
                  <button
                    onClick={() => go(item.path)}
                    className="text-gray-400 hover:text-white text-sm transition-colors"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">Informationen</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Sendung verfolgen', path: '/track' },
                { label: 'Garantie', path: '/garantie' },
                { label: 'Blog', path: '/blog' },
                { label: 'Kontakt', path: '/kontakt' },
                { label: 'AGB', path: '/agb' },
                { label: 'Impressum', path: '/impressum' },
                { label: 'Datenschutz', path: '/datenschutz' },
              ].map((item) => (
                <li key={item.path}>
                  <button
                    onClick={() => go(item.path)}
                    className="text-gray-400 hover:text-white text-sm transition-colors"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-gray-300 uppercase tracking-wider mb-4">Kontakt</h4>
            <div className="space-y-3">
              <a
                href="https://wa.me/491605010907"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2.5 text-gray-400 hover:text-white text-sm transition-colors"
              >
                <PhoneIcon className="h-4 w-4 shrink-0" />
                0160-5010907
              </a>
              <a
                href="mailto:service@phone-medic.de"
                className="flex items-center gap-2.5 text-gray-400 hover:text-white text-sm transition-colors"
              >
                <EnvelopeIcon className="h-4 w-4 shrink-0" />
                service@phone-medic.de
              </a>
              <div className="flex items-start gap-2.5 text-gray-400 text-sm">
                <MapPinIcon className="h-4 w-4 shrink-0 mt-0.5" />
                Regensburg, Deutschland
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 py-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} PhoneMedic – Alle Rechte vorbehalten.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {[
              { label: 'Impressum', path: '/impressum' },
              { label: 'Datenschutz', path: '/datenschutz' },
              { label: 'AGB', path: '/agb' },
              { label: 'Batteriehinweis', path: '/batteriehinweis' },
              { label: 'Cookies', path: '/cookies' },
            ].map((item) => (
              <button
                key={item.path}
                onClick={() => go(item.path)}
                className="text-gray-500 hover:text-gray-300 text-sm transition-colors"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
